import { Member } from 'src/features/member/types'
import { GetPatientReturn } from 'src/features/patient/api'
import { ObservationType } from 'src/lib/gql-client/client-preset/graphql'

import { WorksheetFieldStickiesProvider } from './WorksheetFieldStickies'
import { WorksheetValueProvider } from './WorksheetValue'
import { WorksheetDetail } from '../types'

type ProviderProps = {
  fetchedWorksheet: WorksheetDetail
  mutateWorksheet: () => void
  children: React.ReactNode
  member: Member
  observationType: ObservationType
  selectedTrialHospitalRole: 'Main' | 'Partner' | null
  patient: GetPatientReturn
}

export const WorksheetProvider: React.FC<ProviderProps> = ({
  fetchedWorksheet,
  mutateWorksheet,
  member,
  selectedTrialHospitalRole,
  observationType,
  patient,
  children,
}) => {
  return (
    <WorksheetValueProvider
      fetchedWorksheet={fetchedWorksheet}
      member={member}
      patient={patient}
      selectedTrialHospitalRole={selectedTrialHospitalRole}
      observationType={observationType}
    >
      <WorksheetFieldStickiesProvider
        fetchedWorksheet={fetchedWorksheet}
        mutateWorksheet={mutateWorksheet}
      >
        {children}
      </WorksheetFieldStickiesProvider>
    </WorksheetValueProvider>
  )
}
